<script lang="ts" setup>
  /**
   * The Russia/Belarus service restriction, stated inline against the field it
   * applies to. Render it while isRestrictedCountry() holds for that field's
   * selection, and keep the form's submit disabled for as long.
   */
</script>

<template>
  <div class="restricted-country-notice" role="alert">
    <svg
      class="restricted-country-notice__icon"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="square"
      aria-hidden="true"
      focusable="false"
    >
      <circle cx="12" cy="12" r="9" />
      <line x1="12" y1="8" x2="12" y2="13" />
      <line x1="12" y1="16.5" x2="12" y2="16.5" />
    </svg>
    <p class="restricted-country-notice__text">
      Due to the ongoing war of aggression against Ukraine, Bahnhof.cloud services are not available in Russia or
      Belarus. This restriction will remain in place until further notice. Customers who attempt to circumvent this
      restriction and are later identified as residents or citizens of these countries risk immediate termination of
      their services without prior notice.
    </p>
  </div>
</template>

<style scoped lang="scss">
  .restricted-country-notice {
    display: flex;
    gap: var(--bf-sp-2);
    align-items: flex-start;
    padding: 14px 16px;
    background: var(--bf-restricted-bg);
    border: 1px solid var(--bf-restricted-border);
    border-left: 3px solid var(--bf-restricted-accent);
    border-radius: var(--bf-r-lg);
  }

  .restricted-country-notice__icon {
    flex-shrink: 0;
    margin-top: 1px;
    color: var(--bf-restricted-accent);
  }

  .restricted-country-notice__text {
    margin: 0;
    font-family: var(--bf-font-body);
    font-size: var(--bf-fs-xs);
    line-height: var(--bf-lh-normal);
    color: var(--bf-restricted-text);
    text-wrap: pretty;
  }
</style>
